module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_vm._v("Also by Penelope Lively")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('i', [_vm._v("Fiction")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("GOING BACK")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE ROAD TO LICHFIELD")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NOTHING MISSING BUT THE SAMOVAR AND OTHER STORIES")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("TREASURES OF TIME")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NEXT TO NATURE, ART")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PERFECT HAPPINESS")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CORRUPTION AND OTHER STORIES")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ACCORDING TO MARK")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PACK OF CARDS")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("COLLECTED SHORT STORIES 1978–1986")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("MOON TIGER")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PASSING ON")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CITY OF THE MIND")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CLEOPATRA'S SISTER")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("HEAT WAVE")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("BEYOND THE BLUE MOUNTAINS")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("SPIDERWEB")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('i', [_vm._v("Nonfiction")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE PRESENCE OF THE PAST")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("AN INTRODUCTION TO LANDSCAPE HISTORY")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("OLEANDER, JACARANDA")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("A CHILDHOOD PERCEIVED")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("A HOUSE UNLOCKED")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1f6ebd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Also_by.vue
// module id = 63
// module chunks = 0